import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { DetalleFacturasMalas } from './detalle-facturas/detalle-facturas';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { SettingsService } from 'src/app/settings/settings.service';;
import {Location} from '@angular/common';

declare var $: any;


@Component({
    selector: 'app-detalle-operacion',
    templateUrl: './detalle-operacion.html',
    styleUrls: ['./detalle-operacion.less'],
    standalone: false
})
export class DetailOperationComponent implements OnInit {

  id_op: any;
  id_sim: any;
  constructor(private _location: Location, private router:Router, public settings: SettingsService, public dialog: MatDialog, private activated_router: ActivatedRoute, private snackBar:MatSnackBar) {

    this.activated_router.params.subscribe(params => {
      this.id_op = params['id']
    })

  }

  @Input() id_company:any=localStorage.getItem('company_id');




  myObserver: any;
  ngOnDestroy() {
    this.myObserver.unsubscribe();
    this.detener_refresco();
  }

  /*
   * Refresco al cursar. Antes esta pantalla esperaba `cambios_curse_operacion` (y
   * `descarte_curse_operacion`) por websocket, pero Lemu dejó de publicarlos (LemuBackend #6370)
   * —y ya no le llegaban a nadie: la regla del bus esperaba otra fuente—. En su lugar:
   * se relee en silencio cada minuto mientras la pestaña está visible, con tope de 30 min,
   * y siempre al volver a la pestaña. Si la operación se descartó, el stepper lo muestra al
   * releer (antes el aviso de descarte llevaba a `detalle-operacion/<sim>`).
   */
  private static readonly REFRESCO_MS = 60 * 1000;
  private static readonly TOPE_REFRESCO_MS = 30 * 60 * 1000;
  private refresco_timer: any = null;
  private refresco_inicio = 0;

  private iniciar_refresco() {
    this.detener_refresco();
    this.refresco_inicio = Date.now();
    this.refresco_timer = setInterval(() => {
      if (Date.now() - this.refresco_inicio > DetailOperationComponent.TOPE_REFRESCO_MS) {
        this.detener_refresco();
        return;
      }
      if (!document.hidden) {
        this.get_stepper(true);
      }
    }, DetailOperationComponent.REFRESCO_MS);
  }

  private detener_refresco() {
    if (this.refresco_timer) {
      clearInterval(this.refresco_timer);
      this.refresco_timer = null;
    }
  }

  @HostListener('document:visibilitychange')
  al_volver_a_la_pestana() {
    if (document.hidden || this.id_op == null) {
      return;
    }
    this.get_stepper(true);
    this.iniciar_refresco();
  }

  load_all(){
    window.scrollTo({top: 0, behavior: 'smooth'});
    this.get_stepper()
  }


  is_responsive:boolean=false;
  ngOnInit() {


    if (window.screen.width <= 1024) {
      this.is_responsive = true;
    }

    this.myObserver = this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.load_all();
      }
    });


    this.load_all();
    this.iniciar_refresco();

  }

  formatMoney(amount: any, decimalCount = 2, decimal = ',', thousands = '.') {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
      const negativeSign = amount < 0 ? '-' : '';
      const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      const j = (i.length > 3) ? i.length % 3 : 0;
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands);
    } catch (e) {
    }
  }



  date_created="";
  anticipo:any=0;
  valor_anticipo_total:any=0;
  dias_promedio:any=0;
  tasa_interes:any=0;
  comision:any=0;
  gastos:any=0;
  interes_total:any=0;
  iva_operacion:any=0;
  excedentes:any=0;
  monto_recibir:any=0;
  total:any=0;
  cantidad_facturas:any=0;
  STATUS:any;
  loading:boolean=false;
  id_operacion:any=null;
  has_valid_aecs:boolean=false;
  caso:any="";
  async get_resumen_sim(silencioso: boolean = false){


    try {

      if (!silencioso) {
        this.loading = true;
      }

      const bd: any = await this.settings.get_query(1, '/cliente/simulacion/'+this.id_sim+'/');
      var body_data: any =bd._body;
      var data = body_data.success;
      switch (bd.status) {
        case 200:


          this.STATUS = data.info.status;
          this.cantidad_facturas = data.info.cant_facturas;
          this.has_valid_aecs = data.info.has_valid_aecs;
          this.date_created = data.info.date_created;
          this.anticipo = this.formatMoney(data.info.anticipo);
          this.valor_anticipo_total = this.formatMoney(data.info.valor_anticipo_total);
          this.dias_promedio = data.info.dias_promedio;
          this.tasa_interes = data.info.tasa_interes;
          this.comision = this.formatMoney(data.info.comision);
          this.gastos = this.formatMoney(data.info.gastos);
          this.interes_total = this.formatMoney(data.info.interes_total);
          this.iva_operacion = this.formatMoney(data.info.iva_operacion);
          this.excedentes = this.formatMoney(data.info.excedentes);
          this.monto_recibir = this.formatMoney(data.info.monto_recibir);
          this.total = this.formatMoney(Number(data.info.total));
          this.id_operacion = data.info.id_operacion;

          this.loading = false;



        break;
        default:

        break;
      }

    } catch (bd:any) {

      // Un error en el refresco de fondo no se muestra, pero corta el refresco: `get_query` ya
      // abre su diálogo y manda el correo de los 500, y no tiene sentido repetirlo cada minuto.
      if (silencioso) {
        this.detener_refresco();
        return;
      }

      switch (bd.status) {
        case 500:

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
          break;

        case 400:

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
          break;
        default:

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });

        break;
      }
    }


  }

  monto_girar=0;
  status_text="";
  mensaje="";
  step:any=1;
  is_warning:boolean=false;
  contactar_ejecutivo:boolean=false;
  adjuntar_archivos:boolean=false;
  facturas_con_problema:any[]=[];
  post_verificacion:boolean=false;
  screen:any=1;
  /** `silencioso`: el refresco periódico, sin pantalla de carga ni avisos de error. */
  async get_stepper(silencioso: boolean = false){

    if (!silencioso) {
      this.loading = true;
    }

    try {


      const bd: any = await this.settings.get_query(1, '/cliente/curse-operaciones-detalle/'+this.id_op+'/');
      var body_data: any =bd._body;
      var data = body_data.success;
      switch (bd.status) {
        case 200:


          this.id_sim = data.info.operacion.simulacion_id;
          this.status_text = data.info.operacion.status_text;
          this.monto_girar = data.info.operacion.monto_girar;
          this.mensaje = data.info.step_info.mensaje;
          this.step = data.info.step;
          this.is_warning = data.info.step_info.is_warning;
          this.contactar_ejecutivo = data.info.step_info.contactar_ejecutivo;
          this.adjuntar_archivos = data.info.step_info.adjuntar_archivos;
          this.facturas_con_problema = data.info.step_info.facturas_problema;
          this.post_verificacion = data.info.post_verificacion;
          this.caso = data.info.step_info.caso;
          this.screen = data.info.screen;




          this.get_resumen_sim(silencioso);

  



        break;
        default:

        break;
      }

    } catch (bd:any) {

      // Un error en el refresco de fondo no se muestra, pero corta el refresco: `get_query` ya
      // abre su diálogo y manda el correo de los 500, y no tiene sentido repetirlo cada minuto.
      if (silencioso) {
        this.detener_refresco();
        return;
      }

      console.log(bd)

      switch (bd.status) {
        case 500:

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
          break;

        case 400:

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
          break;
        default:

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });

        break;
      }
    }


  }




  loading_pdf_:boolean=false;
  async download_pdf() {
    try {
      this.loading_pdf_ = true;
  
      const bd: any = await this.settings.get_query(
        1,
        `/cliente/simulacion-detalle-pdf/${this.id_sim}/`
      );
  
      const body_data: any = bd._body;
      const data = body_data.success;
  
      switch (bd.status) {
        case 200:
          console.log('Datos recibidos:', body_data);
  
          if (body_data.respuesta && body_data.respuesta.info) {
            window.open(body_data.respuesta.info, "_blank");
          } else if (data && data.info) {
            window.open(data.info, "_blank");
          } else {
            this.snackBar.open('No se encontró la URL del PDF en la respuesta del servidor', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack',
            });
          }
          this.loading_pdf_ = false;
          break;
  
        default:
          this.loading_pdf_ = false;
          this.snackBar.open('Ocurrió un error al procesar la solicitud', 'Aceptar', {
            duration: 20000,
            panelClass: 'simpli-snack',
          });
          break;
      }
    } catch (error: any) {
      console.error('Error capturado:', error);
      this.loading_pdf_ = false;
  
      switch (error.status) {
        case 500:
          this.snackBar.open('Error del servidor, intenta de nuevo', 'Aceptar', {
            duration: 20000,
            panelClass: 'simpli-snack',
          });
          break;
  
        case 400:
          this.snackBar.open('Solicitud inválida, intenta de nuevo', 'Aceptar', {
            duration: 20000,
            panelClass: 'simpli-snack',
          });
          break;
  
        default:
          this.snackBar.open('Error inesperado, intenta de nuevo', 'Aceptar', {
            duration: 20000,
            panelClass: 'simpli-snack',
          });
          break;
      }
    }
  }
  
  

  volver_a_simular(){
    this.router.navigate(['/home/']);

    setTimeout(() => {
      if( $('#caja_excel').length )
      {
        $("#caja_excel").trigger('click');
      }
    });
  }


  files(){
    console.log(this.id_sim, this.id_op, this.caso)
    this.caso = 2
    this.router.navigate(['home/documentacion/',this.id_sim, this.id_op, this.caso])
  }

  contactar(){
      $("#chatEjecutivo").trigger('click');
  }

  detalle_factura(){
    const dialogRef = this.dialog.open(DetalleFacturasMalas,{
      width: '900px',
      disableClose: true,
      autoFocus: false,
    });

    dialogRef.componentInstance.paginar_front = true;
    dialogRef.componentInstance.facturas = this.facturas_con_problema
    dialogRef.componentInstance.caso = this.caso

    dialogRef.afterClosed().subscribe((result:any) => {
      if(result == true){

      }
    });
  }


  return(){
    //PERO
    this._location.back();
  }



}
